const matchesInitialState = {
  matches: [],
  usedPlayerIds: []
};

export default matchesInitialState;
